module.exports = __webpack_public_path__ + "img/ts02.c888eab1.png";